import { AxiosError, AxiosInstance, AxiosRequestConfig } from "axios";
import httpClient from "./api";

export class BaseService {
  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = httpClient();
  }

  protected async axiosCall<T, E = any>(
    config: AxiosRequestConfig
  ): Promise<{ error: AxiosError<E> | null; data?: T | null }> {
    try {
      const { data } = await this.axiosInstance.request<T>(config);
      return { error: null, data };
    } catch (error: unknown) {
      const err = error as AxiosError<E>;
      return { error: err, data: null };
    }
  }
}
